import { Amplify } from 'aws-amplify';
import type { AuthConfig } from '@aws-amplify/core';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import type { EnvironmentAws } from '../environments/environment.model';

export type { EnvironmentAws };

/**
 * Configura Amplify JS v6 con Cognito User Pool y almacenamiento en cookies
 * (mismo dominio amplio que antes) para sesión entre subdominios.
 */
export function configureAmplify(aws: EnvironmentAws): void {
	const authConfig: AuthConfig = {
		Cognito: {
			userPoolId: aws.aws_user_pools_id,
			userPoolClientId: aws.aws_user_pools_web_client_id,
			//	identityPoolId: aws.aws_cognito_identity_pool_id,
		},
	};

	const cookieStorage = new CookieStorage({
		domain: aws.cookieStorage.domain,
		path: aws.cookieStorage.path,
		secure: aws.cookieStorage.secure,
		sameSite: 'lax',
	});

	cognitoUserPoolsTokenProvider.setAuthConfig(authConfig);
	cognitoUserPoolsTokenProvider.setKeyValueStorage(cookieStorage);

	Amplify.configure(
		{ Auth: authConfig },
		{
			Auth: {
				tokenProvider: cognitoUserPoolsTokenProvider,
			},
		}
	);
}
